import graphql__3aeca60783c069e1b60e from "./__generated__/InterviewChatMessage_message.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import { MESSAGE_ROLE_USER } from "./oralInterviewUiTransitions";

const MESSAGE_ROLE_ASSISTANT = "assistant";

const InterviewChatMessage = props => {
  const message = useFragment(InterviewChatMessage_message, props.message);
  const t = useFormatMessage();

  const isAssistantMessage = message.role === MESSAGE_ROLE_ASSISTANT;
  const displayedRole = isAssistantMessage ? MESSAGE_ROLE_ASSISTANT : MESSAGE_ROLE_USER;
  const roleLabel = isAssistantMessage
    ? t(intlMessages.assistantRole)
    : t(intlMessages.userRole);

  const rowClassName = classNames(
    "oral-interview-chat__row",
    `oral-interview-chat__row--${displayedRole}`
  );
  const messageClassName = classNames(
    "oral-interview-chat__message",
    `oral-interview-chat__message--${displayedRole}`
  );
  const metaClassName = classNames(
    "oral-interview-chat__meta",
    `oral-interview-chat__meta--${displayedRole}`
  );
  const bubbleClassName = classNames(
    "oral-interview-chat__bubble",
    `oral-interview-chat__bubble--${displayedRole}`
  );

  return (
    <div className={rowClassName}>
      <div className={messageClassName}>
        <p className={metaClassName}>{roleLabel}</p>

        <div className={bubbleClassName}>{message.text}</div>
      </div>
    </div>
  );
};

const InterviewChatMessage_message = graphql__3aeca60783c069e1b60e;

export default InterviewChatMessage;

const intlMessages = defineMessages({
  assistantRole: {
    id: "answer.oralInterview.assistantRole",
    defaultMessage: "Interviewer"
  },
  userRole: {
    id: "answer.oralInterview.userRole",
    defaultMessage: "Vous"
  }
});
